import React from "react";
import { useEffect } from "react";
import img2 from "./images/churma.jpg";
import img3 from "./images/bati.jpg";
import img4 from "./images/acharmenu.webp";
import img5 from "./images/dallmenu.webp";
import img6 from "./images/kadimenu.webp";
import img7 from "./images/pulao.jpg";
import img8 from "./images/gchutni.jpg";
import img9 from "./images/pappdmenu.webp";
import img11 from "./images/noodles.jpg";
import img12 from "./images/poori.webp";
import img13 from "./images/panner.webp";
import img14 from "./images/bharta.webp";

import welcomeImg from "./images/tandb.png";

const MenuCards = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const menuItems = [
    { name: "Daal", image: img5 },
    { name: "Baati", image: img3 },
    { name: "Churma", image: img2 },
    { name: "Poori", image: img12 },
    { name: "Matar Paneer", image: img13 },
    { name: "Baingan Bharta", image: img14 },
    { name: "Kabuli Pulav", image: img7 },
    { name: "Gatta Kadhi", image: img6 },
    { name: "Chowmin", image: img11 },
    { name: "Lehsun Chutney", image: img8 },
    { name: "Achar", image: img4 },
    { name: "Papad & Salad", image: img9 },
  ];

  return (
    <div className="menu-wrapper">
      <div className="welcome-card">
        <div className="welcome-heading">WELCOME REFRESHMENTS</div>
        <div className="welcome-img-wrap">
          <img
            src={welcomeImg}
            alt="Welcome Refreshments"
            className="welcome-bg-img"
          />
          <div className="welcome-labels">
            <span className="welcome-item-label">Refreshing Thandai</span>
            <span className="welcome-item-label">Delicious Gujiya</span>
          </div>
        </div>
      </div>

      {/* ===== MENU CARDS ===== */}
      <div className="menu-cards-container">
        <div className="menu-grid">
          {menuItems.map((item, index) => (
            <div key={index} className="menu-card">
              <div className="menu-card-content">
                <div className="menu-card-text">{item.name}</div>
                <div className="menu-card-image">
                  <img src={item.image} alt={item.name} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        .menu-wrapper {
          width: 100%;
          background-color: #fff5e6;
          position: relative;
          padding: 16px 16px 0;
        }

        /* ===== WELCOME CARD ===== */
        .welcome-card {
          width: 100%;
          border-radius: 20px;
          margin-bottom: 20px;
          overflow: hidden;
          box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
          background: #f9a825;
        }

        /* Heading sits above image — never overlaps */
        .welcome-heading {
          width: 100%;
          text-align: center;
          padding: 12px 60px 8px;
          font-family: "Georgia", "Times New Roman", serif;
          font-size: clamp(16px, 3vw, 36px);
          font-weight: 900;
          color: #2c1a00;
          letter-spacing: 1px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          background: #f9a825;
        }

        .welcome-heading .namaste {
          font-size: clamp(16px, 2.5vw, 32px);
        }

        /* Image container */
        .welcome-img-wrap {
          position: relative;
          width: 100%;
          aspect-ratio: 16 / 5;
        }

        .welcome-bg-img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: fill;
          display: block;
        }

        /* Labels pinned at bottom of image */
        .welcome-labels {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: space-between;
          padding: 0 10% 4%;
          z-index: 2;
        }

        .welcome-item-label {
          font-family: "Georgia", serif;
          font-size: clamp(11px, 1.5vw, 20px);
          font-weight: 800;
          color: #2c1a00;
          text-shadow: 0 1px 4px rgba(255, 255, 255, 0.5);
        }

        @media (max-width: 768px) {
          .welcome-card {
            border-radius: 16px;
          }
          .welcome-heading {
            padding: 10px 44px 6px;
          }
          .welcome-img-wrap {
            aspect-ratio: 16 / 6;
          }
        }

        @media (max-width: 480px) {
          .welcome-card {
            border-radius: 12px;
          }
          .welcome-heading {
            padding: 8px 36px 4px;
          }
          .welcome-img-wrap {
            aspect-ratio: 16 / 7;
          }
          .welcome-labels {
            padding: 0 6% 5%;
          }
        }

        /* ===== MENU CARDS CONTAINER ===== */
        .menu-cards-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 20px;
          overflow-x: hidden;
          position: relative;
          will-change: auto;
        }

        .menu-cards-container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-image: url("https://t3.ftcdn.net/jpg/12/42/59/04/360_F_1242590497_fcNb4fNbKtPn0TmjGRdnqcLiHshGRSs5.jpg");
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          opacity: 0.15;
          z-index: 0;
          pointer-events: none;
          backface-visibility: hidden;
        }

        /* ===== GRID ===== */
        .menu-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          margin-bottom: 20px;
          width: 100%;
          position: relative;
          z-index: 1;
        }

        .menu-card {
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
          cursor: pointer;
          height: 140px;
          position: relative;
          z-index: 1;
          will-change: transform;
        }

        .menu-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
        }

        .menu-card-content {
          display: flex;
          align-items: stretch;
          height: 100%;
        }

        .menu-card-text {
          flex: 1;
          padding: 20px 15px;
          background: linear-gradient(135deg, #e8f4ff 0%, #ffffff 100%);
          font-weight: 700;
          font-size: 18px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1.2;
        }

        .menu-card-image {
          flex: 1;
          height: 100%;
          overflow: hidden;
        }

        .menu-card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 1024px) {
          .menu-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .welcome-card {
            border-radius: 16px;
          }
          .menu-card {
            height: 120px;
          }
          .menu-card-text {
            font-size: 15px;
            padding: 10px 8px;
          }
        }

        @media (max-width: 640px) {
          .menu-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 480px) {
          .menu-wrapper {
            padding: 12px 12px 0;
          }
          .welcome-card {
            border-radius: 12px;
          }
          .welcome-labels {
            padding: 0 6% 5%;
          }
          .menu-cards-container {
            padding: 12px;
          }
          .menu-grid {
            gap: 15px;
            grid-template-columns: 1fr;
          }
          .menu-card {
            height: 120px;
          }
          .menu-card-text {
            padding: 15px 12px;
            font-size: 15px;
          }
        }
      `}</style>
    </div>
  );
};

export default MenuCards;
